module.exports = require("@opentelemetry/instrumentation");